import { getAuth0Client } from '~auth';
import { resetTracking } from '~src/tracking';

export const logoutRoute = async () => {
  const auth0 = await getAuth0Client();

  const returnTo = `${window.location.origin}${process.env.ROUTE_LOGIN}`;

  localStorage.clear();

  auth0.logout({
    returnTo: returnTo,
  });

  resetTracking();
};
